import { t } from '../lib/i18n';

/** Símbolo Nolens: N com quatro nós, o último em teal. O tile tem a cor do produto (ADR-039). */
export function NolensSymbol({ size = 24 }: { size?: number }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden className="shrink-0">
      <rect x="0.5" y="0.5" width="23" height="23" rx="6.5" fill="var(--brand-tile)" />
      <path d="M7 17V7l10 10V7" stroke="#F7F7F5" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      <circle cx="7" cy="7" r="1.6" fill="#F7F7F5" />
      <circle cx="7" cy="17" r="1.6" fill="#F7F7F5" />
      <circle cx="17" cy="7" r="1.6" fill="#F7F7F5" />
      <circle cx="17" cy="17" r="1.9" fill="var(--nolens-bright)" stroke="#F7F7F5" strokeWidth="0.8" />
    </svg>
  );
}

/** Wordmark: símbolo + NOLENS (espaçado) + descritor do produto. */
export function NolensMark({ endorsement = false, size = 'md' }: { endorsement?: boolean; size?: 'sm' | 'md' }) {
  const sm = size === 'sm';
  return (
    <span className="inline-flex items-center gap-2.5" aria-label="Nolens Physio">
      <NolensSymbol size={sm ? 20 : 26} />
      <span className="flex flex-col leading-none">
        <span className={sm ? 'text-[12px]' : 'text-[14px]'}>
          <span className="font-[650] tracking-[0.14em] text-text-1">NOLENS</span>{' '}
          <span className="font-semibold tracking-[0.02em] text-[var(--brand-product)]">Physio</span>
        </span>
        {endorsement && <span className="mt-1.5 text-[11px] text-text-3">{t('app.endorsement')}</span>}
      </span>
    </span>
  );
}

export function PoweredByNolens() {
  return (
    <p className="inline-flex items-center gap-1.5 text-[11px] text-text-3">
      <NolensSymbol size={12} /> Powered by Nolens
    </p>
  );
}
